module.exports = new __parcel__URL__("battlepass_claim_button_active.57234d74.png").toString();